<template>
  <v-layout>
    <!-- Loading -->
    <v-layout v-if="!isOlympiadsFetched" column justify-center align-center class="mt-5">
      <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      <p class="subheading-1 mt-5 primary--text font-weight-bold">Loading...</p>
    </v-layout>
    <!-- If olympiads were downloaded -->
    <v-container v-else>
      <v-layout xs12 class="mb-5">
        <!-- Exercise Details (Left) -->
        <v-flex>
          <h3 class="font-weight-medium">{{ selectedOlympiad.olympiadTitle }}</h3>
          <v-layout>
            <div class="caption db--text mr-5">
              <v-icon small class="mr-1">mdi-clock-outline</v-icon>
              {{ selectedOlympiad.createdAt | dateFormat }}
            </div>
            <div class="caption db--text">
              <v-icon small class="mr-1">mdi-clipboard-outline</v-icon>
              {{ selectedOlympiad.questions.length }} Questions
            </div>
          </v-layout>
        </v-flex>
        <!-- //// Exercise Details (Left) -->
        <!-- Exercise Links (Right) -->
        <v-flex class="text-right">
          <v-flex>
            <v-btn
              v-if="selectedOlympiad.briefLink"
              :href="selectedOlympiad.briefLink"
              target="_blank"
              class="r-btn caption text-capitalize db white--text"
              depressed
            >
              <v-icon small left>mdi-download</v-icon>Download Brief
            </v-btn>
          </v-flex>
          <v-btn
            v-if="selectedOlympiad.youtubeLink"
            :href="selectedOlympiad.youtubeLink"
            target="_blank"
            class="r-btn caption text-capitalize red white--text dr white--text mt-3"
            depressed
          >
            <v-icon small left>mdi-youtube</v-icon>Watch Video
          </v-btn>
        </v-flex>
        <!-- /// Exercise Links (Right) -->
      </v-layout>
      <v-layout class="text-center red--text">{{error }}</v-layout>
      <!-- Quiz Interactive Start -->
      <v-layout v-if="!quizSubmitted.status" class="text-center">
        <v-flex xs12 v-if="!quizStarted">
          <h4 class="db--text mt-5 font-weight-medium">You can start with the Olympiad</h4>
          <v-btn
            @click="quizStarted = true"
            class="r-btn mt-4 db white--text caption"
            depressed
          >Start Olympiad</v-btn>
        </v-flex>
        <v-layout justify-center v-else class="mt-4">
          <v-flex xs8>
            <h4 class="my-4">{{ currentQues + 1 }} / {{ selectedOlympiad.questions.length }}</h4>
            <v-progress-linear class="mb-4" :value="progressBarValue" height="6" rounded striped></v-progress-linear>
            <div v-if="!quizSubmissionLoader" class="text-center">
              <h4 class="db--text font-weight-medium my-4">{{ currentQuestion.ques }}</h4>
              <div
                v-for="op in currentQuestion.ops"
                :key="op.opId"
                class="customRadio pa-2 caption"
              >
                <input type="radio" v-model="selectedOp" :value="op.opId" :id="op.opId" />
                <label :for="op.opId">{{ op.op }}</label>
              </div>
            </div>
            <v-btn
              :loading="quizSubmissionLoader"
              v-if="selectedOp"
              @click="continueQuiz"
              class="r-btn caption text-capitalize gr white--text mt-5"
            >{{ lastQues ? 'Submit' :'Continue' }}</v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
      <v-layout v-else class="text-center">
        <v-flex class="mt-5">
          <p class="font-weight-regular">Successfully submitted! Result will be out soon.</p>
          <v-btn
            depressed
            @click="$router.push('/olympiads')"
            class="r-btn db white--text caption"
          >Go to Olympiads</v-btn>
        </v-flex>
      </v-layout>
      <!-- /// Quiz Interactive Start -->
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  props: ["olympiadId"],
  data() {
    return {
      selectedOlympiad: {},
      error: "",
      olympiads: [],
      quizStarted: false,
      currentQues: 0,
      selectedOp: null,
      answers: [],
      quizSubmissionLoader: false,
      quizSubmitted: {
        status: false
      }
    };
  },
  methods: {
    ...mapActions(["fetchOlympiads", "submitOlympiad", "fetchUserDetails"]),
    ...mapMutations(["switchOlympiadsFetched", "addExerciseId"]),
    async continueQuiz() {
      this.answers.push({
        quesId: this.currentQuestion.quesId,
        opId: this.selectedOp
      });
      if (!this.lastQues) {
        this.currentQues = this.currentQues + 1;
        this.selectedOp = null;
      } else {
        this.quizSubmissionLoader = true;
        const resp = await this.submitOlympiad({
          answers: this.answers,
          olympiadId: this.selectedOlympiad.olympiadId
        });
        if (resp.data.success) {
          this.quizSubmitted.status = true;
          this.addExerciseId(this.selectedOlympiad.olympiadId);
        } else {
          this.error = "Something Went wrong";
          setTimeout(() => {
            this.$router.push("/olympiads");
          }, 3000);
        }
      }
    }
  },
  computed: {
    ...mapGetters(["getOlympiads", "isOlympiadsFetched"]),
    progressBarValue() {
      return (
        (100 / this.selectedOlympiad.questions.length) * (this.currentQues + 1)
      );
    },
    currentQuestion() {
      return this.selectedOlympiad.questions[this.currentQues];
    },
    lastQues() {
      return this.currentQues + 1 === this.selectedOlympiad.questions.length;
    }
  },
  created() {
    // whether olympiads are fetched from the db or not
    if (!this.isOlympiadsFetched) {
      this.$router.push("/olympiads");
    }
    this.olympiads = this.getOlympiads;
    const selectedOlympiad = this.olympiads.find(
      ex => ex.olympiadId === this.olympiadId
    );
    if (selectedOlympiad) {
      this.selectedOlympiad = selectedOlympiad;
    } else {
      this.$router.push("/olympiads");
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isOlympiadsFetched) return next();
    if (!this.quizStarted) return next();
    if (this.quizSubmitted.status) {
      this.switchOlympiadsFetched();
      return next();
    }
    if (this.error) {
      this.fetchUserDetails();
      this.switchOlympiadsFetched();
      return next();
    }
    if (confirm("Are you sure, you want to quit?")) next();
  }
};
</script>
